import React from 'react';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, InputAdornment, TextField, Typography } from '@material-ui/core';

import { ButtonClearInput } from '../../button';
import { AddressSearchDialog } from '../../address';
import { REQUESTER_FIELDS, useRequesterForm } from './requesterShared';

// 의뢰자 정보(모바일) — 출발지·도착지 블록과 같은 입력창 틀(.formArea .textBox)로 세로로 쌓는다
const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  half: {
    '&:first-child .MuiInputBase-root': { marginRight: 5 },
  },
  addressField: {
    cursor: 'pointer',
    '& input': { cursor: 'pointer' },
  },
}));

function RequesterInfoM({ cmStore, loginStore }) {
  const cs = useStyles();
  const { requester, handleChange, addrOpen, openAddress, closeAddress, selectAddress } = useRequesterForm(cmStore, loginStore);
  const [company, dept, name, tel] = REQUESTER_FIELDS;

  const field = (f, props = {}) => (
    <TextField
      fullWidth
      variant="outlined"
      className="formArea textBox"
      name={f.name}
      placeholder={f.placeholder}
      value={requester[f.name]}
      onChange={handleChange}
      inputProps={{ autoComplete: f.autoComplete, inputMode: f.inputMode }}
      {...props}
    />
  );

  return (
    <Grid className={cs.root} container direction="column" justify="center" alignItems="flex-start">
      <AddressSearchDialog open={addrOpen} type="requester" handleClose={closeAddress} onSelect={selectAddress} />
      <Typography variant="body2" color="textPrimary" gutterBottom><b>의뢰자 정보</b></Typography>
      <Grid container direction="row" spacing={0}>
        <Grid item xs={6} className={cs.half}>{field(company)}</Grid>
        <Grid item xs={6}>{field(dept)}</Grid>
      </Grid>
      <Grid container direction="row" spacing={0}>
        <Grid item xs={5} className={cs.half}>{field(name)}</Grid>
        <Grid item xs={7}>{field(tel)}</Grid>
      </Grid>
      <TextField
        fullWidth
        disabled
        variant="outlined"
        className={`formArea textBox ${cs.addressField}`}
        placeholder="주소"
        value={requester.addr}
        onClick={openAddress}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end"><ButtonClearInput /></InputAdornment>
          ),
        }}
      />
      <TextField
        fullWidth
        variant="outlined"
        className="formArea textBox"
        name="addrDtl"
        placeholder="상세주소"
        value={requester.addrDtl}
        onChange={handleChange}
      />
    </Grid>
  );
}

export default inject('cmStore', 'loginStore')(observer(RequesterInfoM));
